import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import placeholderImage from '../../../../../../assets/images/access_placeholder.svg'
import { checkRole } from '../../../../../../helpers/helpers'
import { useStore } from '../../../../../../mobx-store/context'
import ResourceModal from '../../../../components/ResourceAccessModal/resourceModal'
import { Button, Description, Wrap } from './style'

const data = {
  tracking: {
    title: 'ComplianceSource',
    variable: 'have_access_to_tracking',
    successMessage: 'Access to ComplianceSource granted',
  },
  resource: {
    title: 'ReSource',
    variable: 'have_access_to_resource',
    successMessage: 'Access to ReSource granted',
  },
}

const Placeholder = ({ toggleAccess, loading, myType }) => {
  const store = useStore()
  const params = useParams()
  const [visible, setVisible] = useState(false)

  const type = params.type || 'tracking'

  const onClick = () => {
    if (loading) return

    if (type === 'resource' && !store.company?.[0].have_access_to_resource) {
      setVisible(true)
      return
    }

    toggleAccess(data[type].variable, true)
  }

  const onClose = () => setVisible(false)

  return (
    <>
      {visible && <ResourceModal onClose={onClose} type={type} />}
      <Wrap>
        <img src={placeholderImage} alt='man-and-woman' />
        <div style={{ marginLeft: 30 }}>
          <Description>
            Give access to {data[type].title} for this user. You’ll be able to
            assign which guides and jurisdictions they have access too. To
            modify your plan,
            <Link to={'/resource/options'}> click here</Link>.
          </Description>
          {checkRole([myType], ['admin']) && (
            <Button onClick={onClick}>Add User to {data[type].title}</Button>
          )}
        </div>
      </Wrap>
    </>
  )
}

export default Placeholder
